export const tableHeader = [
  {
    name: '№',
    key: 'number',
  },
  {
    name: 'ФИО',
    key: 'fio',
  },
  {
    name: 'Телефон',
    key: 'phone',
  },
  {
    name: 'Почта',
    key: 'email',
  },
  {
    name: 'Доклад',
    key: 'report',
  },
  {
    name: 'Организация',
    key: 'organization',
  },
  {
    name: 'Форма участия',
    key: 'participationForm',
  },
  {
    name: 'Статус участия',
    key: 'participationStatus',
  },
  {
    name: 'Форма оплаты',
    key: 'paymentForm',
  },
  {
    name: 'Сумма оргвзноса',
    key: 'sumOrgWznos',
  },
  {
    name: 'Подтверждение',
    key: 'confirmation',
  },
];
